import React, { Fragment, useContext } from 'react'
import { Alert } from "react-bootstrap"

import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import ClickToOpenCardDark from '../../components/ClickToOpenCardDark.js'
import ButtonParam from './ButtonParam.js'


/**
 * Device Security section — shows whether the wallet is remembered on this
 * device and offers to forget it.
 */
const SectionDeviceSecurity = () => {
	const userContext = useContext(UserContext)

	return (
		<Fragment>
			<ClickToOpenCardDark title="Device Security">
				<center><br />
					{userContext.has_remembered_wallet() ? (
						<Fragment>
							<Alert variant="info" style={{ fontSize: "16px", margin: "0" }}>
								<i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
								Your wallet is stored encrypted on this device. You can clear it below.
							</Alert><br />

							<ButtonParam
								onClick={() => {
									userContext.clear_remembered_encrypted_wallet()
									alert("This wallet has been forgotten from this device. You will need your seed phrase or backup file to restore it after your close this tab.")
								}}
							>
								Forget this wallet on this device
							</ButtonParam>
						</Fragment>
					) : (
						<div style={{ color: "silver" }}>
							This wallet is not remembered on this device.<br />
							You will need your seed phrase or backup file to restore it after your close this tab.
						</div>
					)}
					<br />
				</center>
			</ClickToOpenCardDark>
			<br />
		</Fragment>
	)
}

export default SectionDeviceSecurity
